module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Simulador de Consórcio","short_name":"Simulador","start_url":"/","background_color":"#ffffff","theme_color":"#142365","display":"standalone","icon":"src/assets/images/guerra-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"d1ce749d3ca55e98e6674a572c076d26"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
